import type { FaireProductEntity } from "../../entity_types/product";

export const p_5gefr7p29d: FaireProductEntity = {
  token: "p_5gefr7p29d",
  type: "product",
  name: "Zaid 18K Gold Non-Tarnish Mini CZ Stud",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/e57788da0f7ef314ebc8cca5be45a00521c9ee6ce59bd7bb901dc67c514ce757.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0ea93d949368dafbce9dff76c6f6763b27c3a221c896a38c1aab53b7c14176e1.jpeg",
    "https://cdn.faire.com/fastly/cdc9c8865dca8a89cca73b1bd3d95beb507e6131dd6dc0ba06b93df121a340c8.jpeg",
    "https://cdn.faire.com/fastly/06890897b97a8dd38079a13efe46b78dbdc972f7adf9c869128ef879e1dd2945.jpeg",
  ],
  priceDollars: 6.13,
  description:
    "18K Gold Non-Tarnish Mini CZ Stud\n18K Gold Plating\nStainless Steel\nCubic Zirconia\nMeasurement (L x W inch): 0.40 inx0.15 in\n \n- Lead-free, Nickel-safe\n- Hypoallergenic\n- Water Resistant",
  tags: [],
  msrpDollars: 19.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:25:58.588Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
